/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Flight } from './Flight';
import {
    FlightFromJSON,
    FlightFromJSONTyped,
    FlightToJSON,
    FlightToJSONTyped,
} from './Flight';
import type { CheckinTime } from './CheckinTime';
import {
    CheckinTimeFromJSON,
    CheckinTimeFromJSONTyped,
    CheckinTimeToJSON,
    CheckinTimeToJSONTyped,
} from './CheckinTime';
import type { CruiseAttribute } from './CruiseAttribute';
import {
    CruiseAttributeFromJSON,
    CruiseAttributeFromJSONTyped,
    CruiseAttributeToJSON,
    CruiseAttributeToJSONTyped,
} from './CruiseAttribute';
import type { Itinerary } from './Itinerary';
import {
    ItineraryFromJSON,
    ItineraryFromJSONTyped,
    ItineraryToJSON,
    ItineraryToJSONTyped,
} from './Itinerary';
import type { Region } from './Region';
import {
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
    RegionToJSONTyped,
} from './Region';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
    ShipToJSONTyped,
} from './Ship';
import type { CabinCategory } from './CabinCategory';
import {
    CabinCategoryFromJSON,
    CabinCategoryFromJSONTyped,
    CabinCategoryToJSON,
    CabinCategoryToJSONTyped,
} from './CabinCategory';
import type { PriceModelOffer } from './PriceModelOffer';
import {
    PriceModelOfferFromJSON,
    PriceModelOfferFromJSONTyped,
    PriceModelOfferToJSON,
    PriceModelOfferToJSONTyped,
} from './PriceModelOffer';

/**
 * 
 * @export
 * @interface Cruise
 */
export interface Cruise {
    /**
     * The id used to identify the cruise
     * @type {string}
     * @memberof Cruise
     */
    cruiseId?: string;
    /**
     * The duration of the cruise
     * @type {number}
     * @memberof Cruise
     */
    duration?: number;
    /**
     * The departure date
     * @type {string}
     * @memberof Cruise
     */
    departureDate?: string;
    /**
     * The arrival date
     * @type {string}
     * @memberof Cruise
     */
    arrivalDate?: string;
    /**
     * 
     * @type {Itinerary}
     * @memberof Cruise
     */
    itinerary?: Itinerary;
    /**
     * List of visited regions
     * @type {Array<Region>}
     * @memberof Cruise
     */
    regions?: Array<Region>;
    /**
     * 
     * @type {Ship}
     * @memberof Cruise
     */
    ship?: Ship;
    /**
     * 
     * @type {PriceModelOffer}
     * @memberof Cruise
     */
    priceModel?: PriceModelOffer;
    /**
     * List of cabinCategories incl. pricings
     * @type {Array<CabinCategory>}
     * @memberof Cruise
     */
    cabinCategories?: Array<CabinCategory>;
    /**
     * 
     * @type {Flight}
     * @memberof Cruise
     */
    bestPriceFlight?: Flight;
    /**
     * 
     * @type {CheckinTime}
     * @memberof Cruise
     */
    checkinTime?: CheckinTime;
    /**
     * List of cruise attributes
     * @type {Array<CruiseAttribute>}
     * @memberof Cruise
     */
    cruiseAttributes?: Array<CruiseAttribute>;
    /**
     * Flag to indicate that flex flight is bookable
     * @type {boolean}
     * @memberof Cruise
     */
    flexFlight?: boolean;
}

/**
 * Check if a given object implements the Cruise interface.
 */
export function instanceOfCruise(value: object): value is Cruise {
    return true;
}

export function CruiseFromJSON(json: any): Cruise {
    return CruiseFromJSONTyped(json, false);
}

export function CruiseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cruise {
    if (json == null) {
        return json;
    }
    return {
        
        'cruiseId': json['cruiseId'] == null ? undefined : json['cruiseId'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'departureDate': json['departureDate'] == null ? undefined : json['departureDate'],
        'arrivalDate': json['arrivalDate'] == null ? undefined : json['arrivalDate'],
        'itinerary': json['itinerary'] == null ? undefined : ItineraryFromJSON(json['itinerary']),
        'regions': json['regions'] == null ? undefined : ((json['regions'] as Array<any>).map(RegionFromJSON)),
        'ship': json['ship'] == null ? undefined : ShipFromJSON(json['ship']),
        'priceModel': json['priceModel'] == null ? undefined : PriceModelOfferFromJSON(json['priceModel']),
        'cabinCategories': json['cabinCategories'] == null ? undefined : ((json['cabinCategories'] as Array<any>).map(CabinCategoryFromJSON)),
        'bestPriceFlight': json['bestPriceFlight'] == null ? undefined : FlightFromJSON(json['bestPriceFlight']),
        'checkinTime': json['checkinTime'] == null ? undefined : CheckinTimeFromJSON(json['checkinTime']),
        'cruiseAttributes': json['cruiseAttributes'] == null ? undefined : ((json['cruiseAttributes'] as Array<any>).map(CruiseAttributeFromJSON)),
        'flexFlight': json['flexFlight'] == null ? undefined : json['flexFlight'],
    };
}

export function CruiseToJSON(json: any): Cruise {
    return CruiseToJSONTyped(json, false);
}

export function CruiseToJSONTyped(value?: Cruise | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cruiseId': value['cruiseId'],
        'duration': value['duration'],
        'departureDate': value['departureDate'],
        'arrivalDate': value['arrivalDate'],
        'itinerary': ItineraryToJSON(value['itinerary']),
        'regions': value['regions'] == null ? undefined : ((value['regions'] as Array<any>).map(RegionToJSON)),
        'ship': ShipToJSON(value['ship']),
        'priceModel': PriceModelOfferToJSON(value['priceModel']),
        'cabinCategories': value['cabinCategories'] == null ? undefined : ((value['cabinCategories'] as Array<any>).map(CabinCategoryToJSON)),
        'bestPriceFlight': FlightToJSON(value['bestPriceFlight']),
        'checkinTime': CheckinTimeToJSON(value['checkinTime']),
        'cruiseAttributes': value['cruiseAttributes'] == null ? undefined : ((value['cruiseAttributes'] as Array<any>).map(CruiseAttributeToJSON)),
        'flexFlight': value['flexFlight'],
    };
}

